export default __webpack_public_path__ + "79a9ce819e81c1b4283b37f04a0c74a4.png";